import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import React from 'react';

interface CarouselProps {
  type?: 'loop' | 'slide';
  arrows?: boolean;
  pagination?: boolean;
  perPage?: number;
  items: React.ReactNode[];
  gap?: string | number;
}

const CarouselBlackArrow = ({
  type = 'loop',
  arrows = true,
  pagination = true,
  perPage = 1,
  items = [],
  gap = '12px',
}: CarouselProps) => {
  return (
    <Splide
      aria-label="Carousel"
      hasTrack={false}
      options={{
        type,
        arrows,
        pagination,
        perPage,
        gap,
      }}
    >
      <div className="relative">
        <SplideTrack>
          {items.map((item, index) => (
            <SplideSlide key={index}>{item}</SplideSlide>
          ))}
          {}
        </SplideTrack>
      </div>
    </Splide>
  );
};

export default CarouselBlackArrow;
